import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, useMediaQueryContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import { useOfferGiftCardCreationMutation } from './queries/useOfferGiftCardCreationMutation'

type CreateGiftCardProductButtonProps = {
  onSuccess: () => void
}

export const CreateGiftCardProductButton = ({ onSuccess }: CreateGiftCardProductButtonProps) => {
  const navigate = useNavigate()
  const { tablet } = useMediaQueryContext()

  const { offerGiftCardCreationMutation } = useOfferGiftCardCreationMutation({
    onSuccess: ({ id }) => {
      onSuccess()

      navigate(
        `${reverse(routing.products.giftCard.giftCardId.self, { giftCardId: id })}${location.search}`,
      )
    },
  })

  return (
    <Button
      fullWidth={!tablet}
      label="Sell gift cards"
      loading={offerGiftCardCreationMutation.isLoading || offerGiftCardCreationMutation.isSuccess}
      size="xsmall"
      onClick={async () => {
        await offerGiftCardCreationMutation.mutateAsync([])
      }}
    />
  )
}
